const otherProjects = [
  {
    id: 1,
    title: "Github Tracker",
    image: "https://i.ibb.co/xYS9DLY/Github-Tracker.png",
    netlify: "https://kriss-github-tracker.netlify.app/",
    heading: "MY OWN GITHUB TRACKER",
    description:
      "Responsive web site keeping track of some of my GitHub repositorys, using endpoints from the GitHub API.",
    github: "https://github.com/silvertejp89/project-github-tracker",
    tools: ["HTML5", "CSS", "JavaScript ES6", "Node.js", "API"],
  },
  {
    id: 2,
    title: "Weather App",
    netlify: "https://thebetterfoxes.netlify.app/",
    heading: "WEATHER APP",
    description:
      "Simple weather dashboard that tells todays weather and temperature using a public weather API.",
    github: "https://github.com/silvertejp89/project-weather-app",
    tools: ["HTML5", "CSS", "JavaScript ES6", "Mob-programming"],
  },
  {
    id: 3,
    title: "Survey",
    netlify: "https://dazzling-lovelace-b281db.netlify.app/",
    heading: "SURVEY",
    description: "Survey with controlled forms and summary of answers.",
    github: "https://github.com/silvertejp89/project-survey",
    tools: ["HTML5", "CSS", "React", "UseState", "Controlled Forms"],
  },
];
export default otherProjects;
